import { AfterViewInit, Component, DestroyRef, OnDestroy } from '@angular/core';
import { AppConfigService, CMSLanguageService } from '@markant-platform/shared/data-access';
import { UserService } from '@markant-platform/shared/user/data-access';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

declare global {
  interface Window {
    fwSettings: {
      locale: string;
      widget_id: number;
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    FreshworksWidget: any;
  }
}

@Component({
  selector: 'markant-platform-support-button',
  templateUrl: './support-button.component.html',
  styleUrls: ['./support-button.component.scss'],
})
export class SupportButtonComponent implements AfterViewInit, OnDestroy {
  private scriptSrc = AppConfigService.appConfiguration.supportWidgetUrl;
  private widgetId = AppConfigService.appConfiguration.supportWidgetId;

  private script!: HTMLScriptElement;
  private htmlElement!: HTMLElement | null;

  private activeLang!: string;

  constructor(
    private readonly userService: UserService,
    private readonly cmsLanguageService: CMSLanguageService,
    private readonly destroyRef: DestroyRef
  ) {}

  ngAfterViewInit(): void {
    this.cmsLanguageService.activeCMSLanguage$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(language => {
      this.removeAndDestroyWidget();
      [this.activeLang] = language.split('-');
      this.loadFreshDeskWidget(this.activeLang);
    });
  }

  ngOnDestroy(): void {
    this.removeAndDestroyWidget();
  }

  removeAndDestroyWidget(): void {
    if (this.script && this.htmlElement) {
      const widgetContainer = document.getElementById('freshworks-container');
      widgetContainer?.remove();
      window.FreshworksWidget('destroy');
    }
  }

  loadFreshDeskWidget(language: string): void {
    window.fwSettings = {
      widget_id: this.widgetId,
      locale: language,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !(function (): any {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const n = function (): any {
        // eslint-disable-next-line prefer-rest-params
        n.q.push(arguments);
      };
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      (n.q = []), (window.FreshworksWidget = n);
    })();

    this.script = document.createElement('script');
    this.script.type = 'text/javascript';
    this.script.src = this.scriptSrc;

    this.htmlElement = document.getElementById('freshdeskWidget');

    if (this.htmlElement) {
      this.htmlElement.appendChild(this.script);
      this.userService
        .generateSupportToken()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(dto => {
          window.FreshworksWidget('authenticate', {
            token: dto.token,
            callback: () => {
              this.userService
                .generateSupportToken()
                .pipe(takeUntilDestroyed(this.destroyRef))
                .subscribe((dto: { token: string }) => {
                  window.FreshworksWidget('authenticate', { token: dto.token });
                });
            },
          });
        });
    }
    window.FreshworksWidget('setLabels', {
      de: {
        contact_form: {
          title: 'Ihre Anfrage',
          submit: 'Senden',
          confirmation: 'Vielen Dank für Ihre Anfrage',
        },
      },
    });
  }
}
